import React from "react";
import { Route, Routes } from "react-router-dom";
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from './Firebase/firebase';
import { withRouter } from './withRouter';
import BoardClass from "./views/Board"
import TestBoard from "./views/TestBoard"
import ControlClass from "./views/Control"
import Loading from './components/Loading.js'
import NotFound from './components/NotFound.js'


class RouteClass extends React.Component {
    constructor(props) {
        super(props);
        let team = props.params.team;
        if (team === "kedhills") {
            team = "kedronhillscruisers";
        }

        this.state = {
            currentstart: 0,
            heatsheet: null,
            team: team,
            notFound: false,
        };

        const pullNewHeatSheet = (meetData) => {
            const heatSheetRef = doc(db, 'heatsheets', meetData.currentmeet);
            getDoc(heatSheetRef).then(snap => {
                if (!snap.exists()) {
                    console.log(`Heat sheet [${meetData.currentmeet}] doesn't exist!`);
                    return;
                }
                const data = snap.data();
                this.setState({ heatsheet: data });
                localStorage.setItem('heatsheet', JSON.stringify(data));
                localStorage.setItem('currentmeet', meetData.currentmeet);
            });
        };

        const meetStatusRef = doc(db, 'meetstatus', team);
        this.unsubscribe = onSnapshot(meetStatusRef, snap => {
            if (!snap.exists()) {
                console.log("meetstatus doc doesn't exist!");
                this.setState({ notFound: true });
                return;
            }
            const data = snap.data();
            this.setState({
                currentstart: data.currentstart,
                currentmeet: data.currentmeet,
                notFound: false,
            });
            if (data.currentmeet && data.currentmeet !== localStorage.getItem('currentmeet')) {
                pullNewHeatSheet(data);
            }
        }, err => console.log(`Encountered error: ${err}`));

        getDoc(meetStatusRef).then(snap => {
            if (!snap.exists()) {
                console.log(`meetstatus document does not exist for ${team}!`);
                this.setState({ notFound: true });
                return;
            }
            const meetData = snap.data();
            if (!meetData.currentmeet || meetData.currentmeet === "") {
                console.log(`No current meet!`);
                return;
            }
            if (meetData.currentmeet === localStorage.getItem('currentmeet')) {
                this.setState({ heatsheet: JSON.parse(localStorage.getItem('heatsheet')) });
                return;
            }
            pullNewHeatSheet(meetData);
        }).catch(error => console.log(`Encountered error: ${error}`));
    }

    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }

    render() {
        if (this.state.notFound) {
            return <NotFound team={this.state.team} />;
        }

        const board = <BoardClass {...this.state} {...this.props} />;
        const betaClient = (this.state.heatsheet && this.state.team)
            ? <BoardClass {...this.state} {...this.props} beta={true} />
            : <Loading />;
        const control = this.state.team
            ? <ControlClass {...this.state} {...this.props} />
            : <Loading />;

        return (
            <Routes>
                <Route path="display_board" element={board} />
                <Route path="" element={betaClient} />
                <Route path="console/*" element={control} />
                <Route path="testboard" element={<TestBoard {...this.state} {...this.props} />} />
            </Routes>
        );
    }
}

export default withRouter(RouteClass);
